module.exports = __webpack_public_path__ + "img/luojigouHead.b1a738cc.png";